import { render, staticRenderFns } from "./CommunityBox.vue?vue&type=template&id=1330f0d8&scoped=true"
import script from "./CommunityBox.vue?vue&type=script&lang=js"
export * from "./CommunityBox.vue?vue&type=script&lang=js"
import style0 from "./CommunityBox.vue?vue&type=style&index=0&id=1330f0d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1330f0d8",
  null
  
)

export default component.exports